import { render, staticRenderFns } from "./Projects.vue?vue&type=template&id=6cfeddb4&"
import script from "./Projects.vue?vue&type=script&lang=ts&"
export * from "./Projects.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6cfeddb4')) {
      api.createRecord('6cfeddb4', component.options)
    } else {
      api.reload('6cfeddb4', component.options)
    }
    module.hot.accept("./Projects.vue?vue&type=template&id=6cfeddb4&", function () {
      api.rerender('6cfeddb4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Projects.vue"
export default component.exports